import { useLocation } from 'react-router-dom';
import { useMenu } from '@/contexts/MenuContext';

/**
 * 현재 페이지 경로에 해당하는 메뉴 아이콘을 반환하는 훅
 * @returns 메뉴 아이콘 문자열 또는 null (아이콘이 없거나 메뉴를 찾을 수 없는 경우)
 */
export const useMenuIcon = (): string | null => {
  const location = useLocation();
  const { findMenuByPath } = useMenu();

  const currentPath = location.pathname;
  const menu = findMenuByPath(currentPath);

  return menu?.menuIcon || null;
};

/**
 * 현재 페이지 경로에 해당하는 메뉴 이름을 반환하는 훅
 * @returns 메뉴 이름 문자열 또는 null (메뉴를 찾을 수 없는 경우)
 */
export const useMenuName = (): string | null => {
  const location = useLocation();
  const { findMenuByPath } = useMenu();

  const currentPath = location.pathname;
  const menu = findMenuByPath(currentPath);

  return menu?.menuName || null;
};
